import type { ArticleBlock } from "@/mocks/articles";

export default function ArticleBody({ blocks }: { blocks: ArticleBlock[] }) {
  return (
    <div className="mt-8">
      {blocks.map((block, index) => {
        if (block.type === "heading") {
          return (
            <h2
              key={`block-${index}`}
              id={`section-${index}`}
              className="mt-10 scroll-mt-28 border-l-2 border-primary-500 pl-4 font-heading text-xl font-bold text-foreground-50 md:text-2xl"
            >
              {block.text}
            </h2>
          );
        }
        if (block.type === "quote") {
          return (
            <blockquote
              key={`block-${index}`}
              className="my-7 rounded-r-md border-l-2 border-accent-500 bg-background-900 px-5 py-4 font-heading text-base italic leading-relaxed text-foreground-200 md:text-lg"
            >
              {block.text}
            </blockquote>
          );
        }
        if (block.type === "list") {
          return (
            <ul key={`block-${index}`} className="my-5 space-y-3">
              {block.items?.map((item, itemIndex) => (
                <li key={`item-${itemIndex}`} className="flex gap-3 text-sm leading-relaxed text-foreground-300 md:text-base">
                  <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-primary-500" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={`block-${index}`} className="mt-5 text-sm leading-loose text-foreground-300 md:text-base">
            {block.text}
          </p>
        );
      })}
    </div>
  );
}